import characters from '@/store/actions/characters';
import discounts from '@/store/actions/discounts';
import payments from '@/store/actions/payments';
import strips from '@/store/actions/strips';
import user from '@/store/actions/user';
import seasons from '@/store/actions/seasons';
import utils from '@/store/actions/utils';

export default {
  ...utils,
  ...user,
  ...characters,
  ...discounts,
  ...payments,
  ...strips,
  ...seasons,
};
